import React from 'react';
import { motion } from 'framer-motion';

export function TarotCardFront({ card, position, index = 0, size = "normal" }) {
  const sizeClasses = size === "small" ? "w-24 h-40" : size === "medium" ? "w-32 h-52" : "w-40 h-64 md:w-44 md:h-72";
  const isReversed = card?.is_reversed;

  return (
    <motion.div
      data-testid={`tarot-card-front-${index}`}
      className={`${sizeClasses} relative rounded-md overflow-hidden shadow-xl border-2 border-[#D4AF37]/40`}
      initial={{ rotateY: 90, opacity: 0 }}
      animate={{ rotateY: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "circOut", delay: index * 0.15 }}
    >
      {card?.image_url ? (
        <img
          src={card.image_url}
          alt={card.name}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ transform: isReversed ? 'rotate(180deg)' : 'none' }}
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F0B1E] to-[#1D1129] flex flex-col items-center justify-center p-3 text-center"
          style={{ transform: isReversed ? 'rotate(180deg)' : 'none' }}>
          <span className="text-2xl font-['Playfair_Display'] text-[#D4AF37] mb-1">
            {card?.arcana === "major" ? ["0","I","II","III","IV","V","VI","VII","VIII","IX","X","XI","XII","XIII","XIV","XV","XVI","XVII","XVIII","XIX","XX","XXI"][card?.number] || "" : card?.number}
          </span>
          <p className="text-xs font-['Playfair_Display'] text-[#FFFFF0] leading-tight mt-1">{card?.name}</p>
        </div>
      )}
      {position && (
        <div className="absolute bottom-0 left-0 right-0 bg-black/60 backdrop-blur-sm px-2 py-1 text-center">
          <p className="text-[9px] text-[#D4AF37] tracking-widest uppercase">{position}</p>
        </div>
      )}
      {isReversed && (
        <div className="absolute top-0 left-0 right-0 bg-[#C87886]/80 px-2 py-0.5 text-center">
          <p className="text-[9px] text-white tracking-wider">Reversed</p>
        </div>
      )}
    </motion.div>
  );
}

export function FlippableCard({ card, position, index = 0, isFlipped, onFlip }) {
  return (
    <div className="perspective-1000" data-testid={`flippable-card-${index}`}>
      <motion.div
        className="w-32 h-52 md:w-40 md:h-64 relative cursor-pointer"
        style={{ transformStyle: "preserve-3d" }}
        animate={{ rotateY: isFlipped ? 180 : 0 }}
        transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        onClick={onFlip}
      >
        <div className="absolute inset-0 rounded-md overflow-hidden border-2 border-[#D4AF37]/40" style={{ backfaceVisibility: "hidden" }}>
          <div className="absolute inset-0 bg-gradient-to-br from-[#1D1129] via-[#0F0B1E] to-[#1D1129]" />
          <div className="absolute inset-2 rounded-sm border border-[#D4AF37]/20 flex items-center justify-center">
            <div className="w-10 h-10 rounded-full border border-[#D4AF37]/40 flex items-center justify-center">
              <div className="w-5 h-5 rounded-full bg-[#D4AF37]/20" />
            </div>
          </div>
        </div>
        <div className="absolute inset-0 rounded-md overflow-hidden border-2 border-[#D4AF37]/40"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}>
          {card?.image_url ? (
            <img src={card.image_url} alt={card?.name} className="absolute inset-0 w-full h-full object-cover"
              style={{ transform: card?.is_reversed ? 'rotate(180deg)' : 'none' }} loading="lazy" />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-[#0F0B1E] to-[#1D1129] flex flex-col items-center justify-center p-2 text-center"
              style={{ transform: card?.is_reversed ? 'rotate(180deg)' : 'none' }}>
              <span className="text-xl font-['Playfair_Display'] text-[#D4AF37]">
                {card?.arcana === "major" ? ["0","I","II","III","IV","V","VI","VII","VIII","IX","X","XI","XII","XIII","XIV","XV","XVI","XVII","XVIII","XIX","XX","XXI"][card?.number] || "" : card?.number}
              </span>
              <p className="text-[10px] font-['Playfair_Display'] text-[#FFFFF0] mt-1">{card?.name}</p>
            </div>
          )}
          {card?.is_reversed && (
            <div className="absolute top-0 left-0 right-0 bg-[#C87886]/80 px-1 py-0.5 text-center">
              <p className="text-[8px] text-white">Reversed</p>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
